function ImageModel(BaseModel) {
    'ngInject';

    class Image extends BaseModel {

        constructor(data) {
            super(data);
        }
    }

    return Image;
}

/***
 * @ngdoc service
 * @name BB:Image
 *
 * @description
 * Representation of an Image Object
 *
 * @property {array} iamges An array with event images
 */
angular
    .module('BB')
    .service('ImageModel', ImageModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/image_model.service.js